<template>
  <div class="container">
    <img class="background-pic" src="~/assets/pics/disk_clear/background.png" />
    <!-- <div class="main-content"> -->
    <div class="title-content">{{ languageData.title }}</div>
    <div v-if="operateStatus === 'default'" class="default-content">
      <div class="desc-content">
        <div
          class="title-text"
          :style="languages.lan === 'en' ? 'fontSize: 30px; fontWeight: bold' : ''"
        >
          {{ languageData.pageTitle }}
        </div>
        <div class="subtitle-text">{{ languageData.pageSubtitle }}</div>
        <div class="desc-text">
          {{ languageData.pageDescription }}
        </div>
      </div>
      <el-button class="btn-start" @click="startScan()">{{ languageData.startScan }}</el-button>
    </div>
    <div v-else-if="operateStatus === 'scan'" class="scan-content">
      <div class="scan-title">
        <div class="title-text">{{ languageData.find }}</div>
        <div class="count-text">{{ totalScanSize }}</div>
        <div class="title-text">{{ languageData.clearFiles }}</div>
      </div>
      <div class="scan-process-content">
        <el-progress
          class="scan-process"
          :stroke-width="12"
          :show-text="false"
          :percentage="scanPercent"
          :color="scanPercent === 100 ? '#5cb87a' : '#409eff'"
        ></el-progress>
        <div class="process-text">{{ scanPercent }}%</div>
      </div>
      <div class="timecost-content">{{ languageData.timeCost }}{{ scanTimeCost }}</div>
      <div class="split-line"></div>
      <div class="detail-content">
        <div class="detail-item" v-for="item in scanItemList" :key="item.key">
          <div class="item-name">{{ item.name }}</div>
          <div class="item-desc" :style="languages.lan === 'en' ? 'fontSize: 14px;' : ''">
            {{ item.desc }}
          </div>
          <div class="item-scan-result" :class="getScanStatusStyle(item.scanStatus)">
            {{ languageData[item.scanStatus] }}
          </div>
        </div>
      </div>
      <el-button type="primary" class="btn-cancel" @click="cancelScan">{{
        languageData.cancel
      }}</el-button>
    </div>
    <div v-else-if="operateStatus === 'clear'" class="clear-content">
      <div class="clear-process-container" v-if="clearProcessFlag">
        <div class="process-title">
          <div class="title-text">{{ languageData.clearProcess }}{{ clearProcessTitle }}</div>
          <div class="size-text">{{ clearProcessSize }}</div>
        </div>
        <div class="clear-process-content">
          <el-progress
            class="clear-process"
            :stroke-width="12"
            :show-text="false"
            :percentage="clearPercent"
            :color="clearPercent === 100 ? '#5cb87a' : '#409eff'"
          ></el-progress>
          <div class="process-text">{{ clearPercent }}%</div>
        </div>
        <div class="timecost-content">{{ languageData.timeCost }}{{ clearTimeCost }}</div>
      </div>
      <div class="clear-head" v-else>
        <div class="clear-title">
          <div class="title-text">{{ languageData.scanFinishForClear }}</div>
          <div class="count-text">&nbsp;{{ allClearSizeDisplay }}&nbsp;</div>
          <div class="title-text">{{ languageData.clearFiles }}</div>
        </div>
        <div class="clear-subtitle">
          <div class="subtitle-text">{{ languageData.totalFind }}</div>
          <div class="subtitle-text">&nbsp;{{ totalClearSize }}&nbsp;</div>
          <div class="subtitle-text">{{ languageData.clearFiles }}</div>
        </div>
      </div>
      <div class="split-line"></div>
      <div class="detail-content">
        <div class="detail-head">
          <div class="head-text">{{ languageData.defaultSelected }}</div>
          <div class="detail-total" v-if="languages.lan === 'en'">
            <div class="value-text">{{ selectedClearSizeDisplay }}&nbsp;</div>
            <div class="total-text">{{ languageData.selected }}&nbsp;</div>
            <div class="total-text">
              /&nbsp;{{ allClearSizeDisplay }}&nbsp;{{ languageData.canSelect }}
            </div>
          </div>
          <div class="detail-total" v-else>
            <div class="total-text">{{ languageData.selected }}</div>
            <div class="value-text">&nbsp;{{ selectedClearSizeDisplay }}&nbsp;</div>
            <div class="total-text">
              /&nbsp;{{ languageData.canSelect }}&nbsp;{{ allClearSizeDisplay }}
            </div>
          </div>
        </div>
        <div class="detail-item" v-for="item in scanItemList" :key="item.key">
          <el-tooltip
            :visible-arrow="false"
            effect="dark"
            :content="languageData.notCleanRemind"
            placement="bottom-start"
            :disabled="item.key !== 'other'"
          >
            <el-checkbox
              v-model="item.selectFlag"
              :disabled="item.key === 'other' || clearProcessFlag"
              @change="selectClearItem($event, item)"
            ></el-checkbox>
          </el-tooltip>
          <div class="item-name">{{ item.name }}</div>
          <div class="item-desc" :style="languages.lan === 'en' ? 'fontSize: 14px;' : ''">
            {{ item.desc
            }}<el-link type="primary" class="item-link" @click="showDetail(item)">{{
              languageData.detailLink
            }}</el-link>
          </div>
          <div class="item-total">{{ item.sizeDisplay }}</div>
        </div>
      </div>
      <el-button class="btn-cancel" @click="cancelClear">{{ languageData.cancel }}</el-button>
      <el-button class="btn-clear" @click="clearHandler">{{ languageData.clearHandler }}</el-button>
      <el-dialog :visible.sync="detailVisible">
        <div class="detail-dialog-container">
          <div class="detail-title-content">{{ detailMap.name }}</div>
          <div class="subtitle-content">
            <div class="subtitle-text">{{ detailMap.desc }}</div>
            <div class="size-text">{{ detailMap.totalSize }}</div>
          </div>
          <div class="table-content">
            <el-table stripe :data="detailMap.data">
              <el-table-column
                property="name"
                :label="languageData.name"
                width="300"
              ></el-table-column>
              <el-table-column
                property="size"
                :label="languageData.size"
                align="center"
              ></el-table-column>
            </el-table>
          </div>
          <div class="detail-dialog-bottom"></div>
        </div>
      </el-dialog>
    </div>
    <div v-else-if="operateStatus === 'finish'" class="finish-content">
      <div class="finish-title">{{ languageData.clearFinish }}</div>
      <div class="finish-subtitle">
        <div class="subtitle-text">{{ languageData.hasCleared }}</div>
        <div class="value-text" style="margin: 0 8px">{{ clearedFileSize }}</div>
        <div class="subtitle-text" style="margin-right: 16px">{{ languageData.file }}</div>
        <div class="value-text" style="margin: 0 8px">
          {{ clearedTrace }}{{ languageData.recordUnit }}
        </div>
        <div class="subtitle-text">
          {{ languageData.clearedTrace }}{{ clearedTrace > 1 && languages.lan === 'en' ? 's' : '' }}
        </div>
      </div>
      <div class="time-cost-text">{{ languageData.timeCost }}{{ clearTimeCost }}</div>
      <el-button class="btn-good" @click="finishClear">{{ languageData.good }}</el-button>
    </div>
  </div>
  <!-- <img class="icon-pic" src="~/assets/pics/disk_clear/icon.png" /> -->
  <!-- </div> -->
</template>

<script>
import { mapMutations, mapActions, mapState } from 'vuex';
import socket from 'common/socket';
import tools from 'common/tools';
import { ubtRegister, ubtSendTrace } from 'utils/ubt';

export default {
  inject: ['homeTemplate'],
  watch: {
    languages() {
      this.languageData = this.languages.DiskClear;
      this.languageData.itemList.forEach((v, i) => {
        this.scanItemList[i].name = v.name;
        this.scanItemList[i].desc = v.desc;
        if (v.key === 'privacy') {
          this.scanItemList[i].sizeDisplay =
            this.scanItemList[i].size + this.languageData.recordUnit;
          if (this.scanItemList[i].size > 1 && this.languages.lan === 'en') {
            this.scanItemList[i].sizeDisplay = `${this.scanItemList[i].sizeDisplay}s`;
          }
        }
      });
    },
  },
  computed: {
    ...mapState([
      'debugMode',
      'languages',
      'toolList',
      'userInfo',
      'deviceName',
      'isNewService',
      'isAdministrator',
    ]),
  },
  data() {
    return {
      toolName: 'DiskCleanUp',
      isToolReady: false,
      encryptPath: '',
      toolKey: '',
      toolInfo: [],
      operateStatus: 'default',
      scanItemList: [],
      languageData: {},
      totalScanSize: '',
      scanPercent: 0,
      scanTimeCost: '',
      scanCancelFlag: false,
      clearSizeMap: {},
      selectedClearSize: 0,
      selectedClearSizeDisplay: '',
      totalClearSize: '',
      allClearSizeDisplay: '',
      allClearSize: 0,
      timer: null,
      detailMap: {},
      detailVisible: false,
      clearProcessFlag: false,
      clearPercent: 0,
      clearTimeCost: '',
      clearProcessTitle: '',
      clearProcessSize: '',
      clearedFileSize: '',
      clearedTrace: 0,
      pvId: '',
    };
  },
  created() {
    this.setPageNow(this.toolName);
    this.setHomeHidden(false);
    this.setSearchHidden(true);
    this.setShowFooter(false);
    this.toolInfo = this.toolList.filter((item) => item.name.indexOf(this.toolName) !== -1);
    if (this.toolInfo.length !== 1) {
      this.setErrorTips(`${this.toolName} > getToolInfo > No such little tool`);
      this.saveLog({
        title: 'api_error',
        lan: this.languages.lan,
        target: `${this.toolName} > getToolInfo`,
        description: 'No such little tool!',
      });
      this.setErrorType('apierror');
      this.$router.push('/error');
      return;
    }
    this.languageData = this.languages.DiskClear;
    this.createSoftWareTask();
    this.scanItemList = this.languages.DiskClear.itemList.map((v) => ({
      key: v.key,
      name: v.name,
      desc: v.desc,
      scanStatus: 'waitScan',
      size: 0,
      sizeDisplay: '',
      selectFlag: true,
    }));
    this.pvId = ubtRegister('Disk Clean');
    this.setPvId(this.pvId);
  },
  methods: {
    ...mapMutations([
      'setDebugData',
      'setPageNow',
      'setHomeHidden',
      'setSearchHidden',
      'setShowFooter',
      'setErrorType',
      'setErrorTips',
      'setIsAdministrator',
      'setIsRunning',
      'setPvId',
    ]),
    ...mapActions(['softwareInstall', 'saveLog']),
    async createSoftWareTask() {
      const res = await this.softwareInstall({
        account: this.userInfo.username,
        softwareId: this.toolInfo[0].id,
        pcName: this.deviceName,
      });
      if (res.status === 'failed') {
        this.setErrorTips(`DiskCleanUp > softwareInstall > ${res.data}`);
        this.saveLog({
          title: 'api_error',
          lan: this.languages.lan,
          target: 'DiskCleanUp > softwareInstall',
          description: res.data,
        });
        this.setErrorType('apierror');
        this.$router.push('/error');
        return;
      }
      this.encryptPath = res.data.encryptPath;
      this.toolKey = res.data.key;
      this.homeTemplate.downToolNew('DiskCleanUp', this.toolInfo[0].id, res, async () => {
        this.isToolReady = true;
      });
    },
    getRecentFiles() {
      return new Promise((resolve, reject) => {
        const toolData = {
          lan: 'tools',
          type: 'silent',
          username: `${this.userInfo.username}◎getRecentFiles`,
          softid: this.toolInfo[0].id,
          path: this.encryptPath,
          key: this.toolKey,
        };
        const socketDatas = tools.toUnicode(JSON.stringify(toolData));
        const runCmd = `({"level":"user", "method":"tool_run", "data":"${socketDatas}"})`;
        socket.sendSocket(2, runCmd, (rt) => {
          console.log('getRecentFiles: ', rt);
          try {
            const rst = JSON.parse(rt);
            if (rst.data === 'Tool Exited') {
              const result = { datas: JSON.parse(rst.info) };
              resolve(result);
            }
          } catch {
            reject();
          }
        });
      });
    },
    clearRecentFiles() {
      return new Promise((resolve, reject) => {
        try {
          const toolData = {
            lan: 'tools',
            type: 'silent',
            username: `${this.userInfo.username}◎cleanRecentFiles`,
            softid: this.toolInfo[0].id,
            path: this.encryptPath,
            key: this.toolKey,
          };
          const socketDatas = tools.toUnicode(JSON.stringify(toolData));
          const runCmd = `({"level":"user", "method":"tool_run", "data":"${socketDatas}"})`;
          socket.sendSocket(2, runCmd, (rt) => {
            console.log('clearRecentFiles: ', rt);
            const rst = JSON.parse(rt);
            if (rst.data === 'Tool Exited') {
              const result = { datas: JSON.parse(rst.info) };
              resolve(result);
            }
          });
          // setTimeout(() => {
          //   resolve('clean finish');
          // }, 500);
        } catch {
          reject();
        }
      });
    },
    scanFile(pathKey) {
      return new Promise((resolve, reject) => {
        try {
          const toolData = {
            lan: 'tools',
            type: 'silent',
            username: `${this.userInfo.username}◎pathKey=${pathKey}`,
            softid: this.toolInfo[0].id,
            path: this.encryptPath,
            key: this.toolKey,
          };
          console.log('scan req: ', toolData);
          const socketDatas = tools.toUnicode(JSON.stringify(toolData));
          const runCmd = `({"level":"user", "method":"tool_run", "data":"${socketDatas}"})`;
          socket.sendSocket(2, runCmd, (res) => {
            const response = JSON.parse(res);
            console.log(pathKey, response);
            if (response.data === 'Tool Exited') {
              const result = JSON.parse(response.info);
              if (result.error !== '') {
                this.saveLog({
                  title: 'exe error',
                  lan: this.languages.lan,
                  target: `${this.toolName} > scanFile[${pathKey}]`,
                  description: 'disk clear: scan files failed',
                  reserve4: result.error,
                });
              }
              resolve(result);
            }
          });
        } catch {
          reject();
        }
      });
    },
    async getClearList() {
      const { clearList } = this.languages.DiskClear;
      for (let index = 0; index < clearList.length; index += 1) {
        const el = clearList[index];
        console.log(`${el.key} start!!!!!!!!!`);
        /* eslint-disable */
      }
    },
    async startScan() {
      ubtSendTrace(245278, 'trash_clear', 'click', 'start', '', '', this.pvId);
      this.totalClearSize = '';
      this.selectedClearSize = 0;
      this.scanPercent = 0;
      this.operateStatus = 'scan';
      this.scanCancelFlag = false;
      this.scanItemList = this.languages.DiskClear.itemList.map((v) => ({
        key: v.key,
        name: v.name,
        desc: v.desc,
        scanStatus: 'waitScan',
        size: 0,
        sizeDisplay: '',
        selectFlag: true,
      }));
      let scanTimeCost = 0;
      this.scanTimeCost = '';
      this.scanTimeCost = tools.getTimeCost(scanTimeCost, this.languageData.timeUnit);
      this.timer = setInterval(() => {
        scanTimeCost += 1000;
        this.scanTimeCost = tools.getTimeCost(scanTimeCost, this.languageData.timeUnit);
      }, 1000);
      let count = 0;
      let totalSize = 0;
      let selectedSize = 0;
      for (let index = 0; index < this.scanItemList.length; index += 1) {
        if (this.scanCancelFlag) {
          break;
        }
        const scanItem = this.scanItemList[index];
        scanItem.scanStatus = 'scanProcess';
        const scanKey = scanItem.key;
        if (scanKey === 'privacy') {
          /* eslint-disable */
          await this.getRecentFiles().then((res) => {
            scanItem.size = res.datas;
            scanItem.sizeDisplay = `${scanItem.size}${this.languageData.recordUnit}`;
            if (scanItem.size > 1 && this.languages.lan === 'en') {
              scanItem.sizeDisplay += 's';
            }
          });
        } else {
          scanItem.size = 0;
          const scanFileList = this.languageData.clearList.filter((v) => v.type === scanKey);
          if (scanKey === 'other') {
            scanItem.selectFlag = false;
          }
          for (let idx = 0; idx < scanFileList.length; idx += 1) {
            const scanFileKey = scanFileList[idx].key;
            if (this.scanCancelFlag) {
              break;
            }
            /* eslint-disable */
            await this.scanFile(scanFileKey)
              .then((response) => {
                if (response != null) {
                  totalSize += response.size;
                  scanItem.size += response.size;
                  this.clearSizeMap[scanFileKey] = response.size;
                  if (scanItem.selectFlag) {
                    selectedSize += response.size;
                  }
                }
              })
              .catch(() => {});
            count += 1;
            this.scanPercent = Math.trunc((count / this.languageData.clearList.length) * 100);
          }
          scanItem.sizeDisplay = tools.getByteSizeDisplay(scanItem.size);
        }
        scanItem.scanStatus = 'scanFinish';
      }
      if (this.scanCancelFlag) {
        return;
      }
      this.scanPercent = 100;
      clearInterval(this.timer);
      this.timer = null;
      this.operateStatus = 'clear';
      this.totalClearSize = tools.getByteSizeDisplay(totalSize);
      this.selectedClearSize = selectedSize;
      this.selectedClearSizeDisplay = tools.getByteSizeDisplay(this.selectedClearSize);
      this.allClearSize = selectedSize;
      this.allClearSizeDisplay = tools.getByteSizeDisplay(this.allClearSize);
      this.saveLog({
        title: 'scan file finish',
        lan: this.languages.lan,
        target: 'startScan',
        description: `scan files finish, totalSize: ${this.allClearSizeDisplay}`,
      });
    },
    getScanStatusStyle(key) {
      switch (key) {
        case 'waitScan':
          return 'wait-scan';
        case 'scanProcess':
          return 'scan-processing';
        case 'scanFinish':
          return 'scan-finish';
        default:
          return 'wait-scan';
      }
    },
    cancelScan() {
      this.scanCancelFlag = true;
      this.operateStatus = 'default';
      clearInterval(this.timer);
      this.timer = null;
      this.scanPercent = 0;
      this.totalClearSize = '';
      this.selectedClearSize = 0;
      this.selectedClearSizeDisplay = '';
      this.clearSizeMap = {};
      this.allClearSize = 0;
      this.allClearSizeDisplay = '';
    },
    async clearHandler() {
      if (this.clearProcessFlag) {
        return;
      }
      this.setIsRunning(true);
      this.clearProcessFlag = true;
      this.clearPercent = 0;
      let clearTimeCost = 0;
      this.clearTimeCost = '';
      this.clearTimeCost = tools.getTimeCost(clearTimeCost, this.languageData.timeUnit);
      this.clearedTrace = 0;
      this.timer = setInterval(() => {
        clearTimeCost += 1000;
        this.clearTimeCost = tools.getTimeCost(clearTimeCost, this.languageData.timeUnit);
      }, 1000);
      let count = 0;
      let totalClearSize = 0;
      const clearList = this.scanItemList.filter((v) => v.selectFlag);
      const clearNames = clearList.map((v) => v.name).join(',');
      ubtSendTrace(245278, 'trash_clear', 'click', 'clearnow', clearNames, '', this.pvId);
      for (let i = 0; i < clearList.length; i += 1) {
        if (!this.clearProcessFlag) {
          break;
        }
        const clearItem = clearList[i];
        const clearKey = clearItem.key;
        this.clearProcessTitle = clearItem.name;
        this.clearProcessSize = clearItem.sizeDisplay;
        if (clearKey === 'privacy') {
          await this.clearRecentFiles().then((res) => {
            if (res.datas === 'clean finish') {
              this.clearedTrace = clearItem.size;
            }
          });
        } else {
          const clearFileList = this.languageData.clearList.filter((v) => v.type === clearKey);
          for (let index = 0; index < clearFileList.length; index += 1) {
            if (!this.clearProcessFlag) {
              break;
            }
            const clearFileKey = clearFileList[index].key;
            /* eslint-disable */
            await this.deleteFile(clearFileKey)
              .then((response) => {
                if (response.flag) {
                  totalClearSize += response.size;
                }
              })
              .catch(() => {});
            count += 1;
            this.clearPercent = Math.trunc((count / this.languageData.clearList.length) * 100);
          }
        }
      }
      this.clearPercent = 100;
      clearInterval(this.timer);
      this.timer = null;
      if (!this.clearProcessFlag) {
        return;
      }
      this.setIsRunning(false);
      this.operateStatus = 'finish';
      this.clearProcessFlag = false;
      this.clearedFileSize = tools.getByteSizeDisplay(totalClearSize);
      ubtSendTrace(245278, 'trash_clear', 'clear_suc', '', '', 'selfhelp', this.pvId);
      this.saveLog({
        title: 'clear file finish',
        lan: this.languages.lan,
        target: 'clearHandler',
        description: `clear file finish, totalSize: ${this.clearedFileSize}`,
      });
    },
    deleteFile(clearKey) {
      return new Promise((resolve, reject) => {
        try {
          const toolData = {
            lan: 'tools',
            type: 'silent',
            username: `${this.userInfo.username}◎delKey=${clearKey}`,
            softid: this.toolInfo[0].id,
            path: this.encryptPath,
            key: this.toolKey,
          };
          console.log('del req: ', toolData);
          const socketDatas = tools.toUnicode(JSON.stringify(toolData));
          const runCmd = `({"level":"user", "method":"tool_run", "data":"${socketDatas}"})`;
          socket.sendSocket(2, runCmd, (res) => {
            const response = JSON.parse(res);
            console.log(response);
            if (response.info === 'Tool Run Failed') {
              ubtSendTrace(245278, 'trash_clear', 'error', response.error, '', '', this.pvId);
              this.saveLog({
                title: 'socket error',
                lan: this.languages.lan,
                target: `${this.toolName} > deleteFile[${clearKey}]`,
                description: response.error,
              });
              reject();
            }
            if (response.data === 'Tool Exited') {
              const result = JSON.parse(response.info);
              if (result.message !== '' && result.message !== null) {
                this.saveLog({
                  title: 'exe error',
                  lan: this.languages.lan,
                  target: `${this.toolName} > deleteFile[${clearKey}]`,
                  description: 'disk clear: delete files failed',
                  reserve4: result.message,
                });
              }
              resolve(result);
            }
          });
          // setTimeout(() => {
          //   console.log(clearKey);
          //   resolve(JSON.stringify({ flag: true, message: '', size: 1024 }));
          // }, 100);
        } catch {
          reject();
        }
      });
    },
    cancelClear() {
      this.operateStatus = 'default';
      clearInterval(this.timer);
      this.timer = null;
      this.clearProcessFlag = false;
      this.clearPercent = 0;
      this.clearTimeCost = '';
      this.clearProcessTitle = '';
      this.clearProcessSize = '';
      this.clearedFileSize = '';
      this.clearedTrace = 0;
      this.scanPercent = 0;
      this.scanTimeCost = '';
      this.totalClearSize = '';
      this.selectedClearSize = 0;
      this.selectedClearSizeDisplay = '';
      this.clearSizeMap = {};
      this.allClearSize = 0;
      this.allClearSizeDisplay = '';
      this.setIsRunning(false);
      ubtSendTrace(245278, 'trash_clear', 'click', 'cancel', '', '', this.pvId);
    },
    showDetail(scanItme) {
      if (this.clearProcessFlag) {
        return;
      }
      this.detailMap = {
        name: scanItme.name,
        desc: scanItme.desc,
        totalSize: scanItme.sizeDisplay,
      };
      this.detailVisible = true;
      if (scanItme.key === 'privacy') {
        this.detailMap.data = [
          { name: this.languageData.recentUsedFiles, size: scanItme.sizeDisplay },
        ];
        return;
      }
      const sizeMap = {};
      this.languageData.clearList
        .filter((v) => {
          let checkFlag = v.type === scanItme.key;
          if (!this.isAdministrator) {
            if (checkFlag && v.adminFlag) {
              checkFlag = false;
            }
          }
          return checkFlag;
        })
        .forEach((el) => {
          /* eslint-disable */
          if (sizeMap.hasOwnProperty(el.name)) {
            /* eslint-disable */
            sizeMap[el.name] = sizeMap[el.name] + this.clearSizeMap[el.key];
          } else {
            sizeMap[el.name] = this.clearSizeMap[el.key];
          }
        });
      const data = [];
      for (let index = 0; index < Object.keys(sizeMap).length; index += 1) {
        const name = Object.keys(sizeMap)[index];
        const size = tools.getByteSizeDisplay(sizeMap[name]);
        data.push({ name, size });
      }
      this.detailMap.data = data;
    },
    selectClearItem(selectFlag, clearItem) {
      console.log(this.clearProcessFlag);
      if (this.clearProcessFlag) {
        return;
      }
      if (clearItem.key === 'privacy') {
        return;
      }
      let { selectedClearSize } = this;
      if (selectFlag) {
        selectedClearSize = clearItem.size + selectedClearSize;
      } else {
        selectedClearSize -= clearItem.size;
      }
      this.selectedClearSize = selectedClearSize;
      this.selectedClearSizeDisplay = tools.getByteSizeDisplay(this.selectedClearSize);
    },
    finishClear() {
      this.operateStatus = 'default';
      this.scanItemList = [];
      this.totalScanSize = '';
      this.scanPercen = 0;
      this.scanTimeCost = '';
      this.scanCancelFlag = false;
      this.clearSizeMap = {};
      this.selectedClearSize = 0;
      this.selectedClearSizeDisplay = '';
      this.totalClearSize = '';
      this.allClearSizeDisplay = '';
      this.allClearSize = 0;
      this.timer = null;
      this.detailMap = {};
      this.detailVisible = false;
      this.clearProcessFlag = false;
      this.clearPercent = 0;
      this.clearTimeCost = '';
      this.clearProcessTitle = '';
      this.clearProcessSize = '';
      this.clearedFileSize = '';
      this.clearedTrace = 0;
    },
  },
};
</script>
<style lang="scss">
.container {
  display: flex;
  background: #ffffff;
  position: relative;
  width: 100%;
  height: 100%;

  .background-pic {
    // height: 600px;
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0px;
    left: 0px;
  }

  // .main-content {
  //   position: absolute;
  //   top: 24px;
  //   left: 24px;
  //   width: 1002px;
  //   height: 520px;
  //   // background: rgba(220, 233, 252, 0.5);
  //   // border-radius: 8px;

  // }

  .title-content {
    position: absolute;
    top: 6%;
    left: 4%;
    color: rgb(102, 102, 102);
    font-size: 16px;
    font-weight: 300;
    letter-spacing: 0px;
  }

  .default-content {
    height: 67%;
    position: absolute;
    left: 33%;
    top: 19%;

    .desc-content {
      display: flex;
      flex-direction: column;

      .title-text {
        line-height: 56px;
        color: rgb(20, 102, 222);
        font-size: 40px;
        font-weight: normal;
        letter-spacing: 0px;
      }

      .subtitle-text {
        width: 600px;
        line-height: 33px;
        color: rgb(1, 184, 122);
        font-size: 24px;
        font-weight: 300;
        letter-spacing: 0px;
        margin-top: 24px;
      }

      .desc-text {
        line-height: 22px;
        color: rgb(102, 102, 102);
        font-size: 16px;
        font-weight: 300;
        letter-spacing: 0px;
        margin-top: 40px;
      }
    }

    .btn-start {
      width: 140px;
      height: 40px;
      background: linear-gradient(-74.89deg, rgb(228, 0, 255) -5.38%, rgb(0, 128, 255) 100%);
      border-radius: 4px;
      position: absolute;
      left: 20%;
      bottom: 13%;
      color: rgb(255, 255, 255);
      font-size: 20px;
      font-weight: 600;
      letter-spacing: 0px;
    }
  }

  .scan-content {
    height: 67%;
    width: 76%;
    position: absolute;
    left: 25%;
    top: 10%;
    display: flex;
    flex-direction: column;

    .scan-title {
      display: flex;

      .title-text {
        line-height: 37px;
        color: rgb(51, 51, 51);
        font-size: 26px;
        font-weight: normal;
        letter-spacing: 0px;
      }

      .count-text {
        line-height: 37px;
        color: rgb(255, 149, 0);
        font-size: 26px;
        font-weight: 600;
        letter-spacing: 0px;
      }
    }

    .scan-process-content {
      display: flex;
      height: 28px;
      align-items: center;

      .scan-process {
        width: 90%;
        border-radius: 8px;
      }

      .process-text {
        line-height: 18px;
        color: rgb(51, 51, 51);
        font-size: 12px;
        font-weight: normal;
        letter-spacing: 0px;
        margin-left: 2%;
      }
    }

    .timecost-content {
      line-height: 17px;
      color: rgb(51, 51, 51);
      font-size: 12px;
      font-weight: normal;
      letter-spacing: 0px;
    }

    .split-line {
      width: 94%;
      height: 1px;
      background: rgb(220, 233, 252);
      border-radius: 1px;
      margin-top: 12px;
      margin-bottom: 24px;
    }

    .detail-content {
      display: flex;
      flex-direction: column;

      .detail-item {
        display: flex;
        width: 96%;
        height: 17px;
        margin: 12px 0;
        align-items: center;
        position: relative;

        .item-name {
          width: 16%;
          display: flex;
          line-height: 22px;
          color: rgb(51, 51, 51);
          font-size: 16px;
          font-weight: 600;
          letter-spacing: 0px;
        }

        .item-desc {
          width: 64%;
          display: flex;
          line-height: 22px;
          color: rgb(51, 51, 51);
          font-size: 16px;
          font-weight: normal;
          letter-spacing: 0px;
          margin-left: 24px;
        }

        .item-scan-result {
          position: absolute;
          right: 4%;
          display: flex;
          height: 22px;
          color: rgb(204, 204, 204);
          font-size: 16px;
          font-weight: normal;
          letter-spacing: 0px;
        }

        .wait-scan {
          color: rgb(204, 204, 204);
        }

        .scan-processing {
          color: rgb(20, 102, 222);
        }

        .scan-finish {
          color: rgb(0, 184, 122);
        }
      }
    }

    .btn-cancel {
      position: absolute;
      left: 36%;
      bottom: 4%;
      font-size: 20px;
    }
  }

  .clear-content {
    height: 67%;
    width: 76%;
    position: absolute;
    left: 25%;
    top: 10%;
    display: flex;
    flex-direction: column;

    .clear-head {
      display: flex;
      flex-direction: column;

      .clear-title {
        display: flex;

        .title-text {
          line-height: 37px;
          color: rgb(51, 51, 51);
          font-size: 26px;
          font-weight: normal;
          letter-spacing: 0px;
        }

        .count-text {
          line-height: 37px;
          color: rgb(255, 149, 0);
          font-size: 26px;
          font-weight: 600;
          letter-spacing: 0px;
        }
      }

      .clear-subtitle {
        display: flex;
        margin-top: 8px;

        .subtitle-text {
          line-height: 17px;
          color: rgb(51, 51, 51);
          font-size: 12px;
          font-weight: normal;
          letter-spacing: 0px;
        }
      }
    }

    .clear-process-container {
      display: flex;
      flex-direction: column;

      .process-title {
        display: flex;

        .title-text {
          line-height: 37px;
          color: rgb(51, 51, 51);
          font-size: 26px;
          font-weight: normal;
          letter-spacing: 0px;
        }

        .size-text {
          line-height: 37px;
          color: rgb(255, 149, 0);
          font-size: 26px;
          font-weight: 600;
          letter-spacing: 0px;
        }
      }

      .clear-process-content {
        display: flex;
        height: 28px;
        align-items: center;

        .clear-process {
          width: 88%;
          border-radius: 8px;
        }

        .process-text {
          line-height: 18px;
          color: rgb(51, 51, 51);
          font-size: 12px;
          font-weight: normal;
          letter-spacing: 0px;
          margin-left: 24px;
        }
      }

      .timecost-content {
        line-height: 17px;
        color: rgb(51, 51, 51);
        font-size: 12px;
        font-weight: normal;
        letter-spacing: 0px;
      }
    }

    .split-line {
      width: 92%;
      height: 1px;
      background: rgb(220, 233, 252);
      border-radius: 1px;
      margin-top: 32px;
      margin-bottom: 24px;
    }

    .detail-content {
      display: flex;
      flex-direction: column;

      .detail-head {
        width: 92%;
        height: 17px;
        position: relative;
        margin-bottom: 4px;

        .head-text {
          position: absolute;
          line-height: 17px;
          color: rgb(51, 51, 51);
          font-size: 12px;
          font-weight: normal;
          letter-spacing: 0px;
        }

        .detail-total {
          position: absolute;
          right: 0px;
          display: flex;

          .total-text {
            line-height: 17px;
            color: rgb(51, 51, 51);
            font-size: 12px;
            font-weight: normal;
            letter-spacing: 0px;
          }

          .value-text {
            line-height: 17px;
            color: rgb(255, 149, 0);
            font-size: 12px;
            font-weight: normal;
            letter-spacing: 0px;
          }
        }
      }

      .detail-item {
        display: flex;
        width: 92%;
        height: 17px;
        margin: 12px 0;
        align-items: center;
        position: relative;

        .item-name {
          width: 16%;
          display: flex;
          line-height: 22px;
          color: rgb(20, 102, 222);
          font-size: 16px;
          font-weight: 600;
          letter-spacing: 0px;
          margin-left: 16px;
        }

        .item-desc {
          width: 58%;
          display: flex;
          line-height: 22px;
          color: rgb(51, 51, 51);
          font-size: 16px;
          font-weight: normal;
          letter-spacing: 0px;
          margin-left: 24px;
        }

        .item-link {
          display: flex;
          line-height: 17px;
          color: rgb(20, 102, 222);
          font-size: 12px;
          font-weight: normal;
          letter-spacing: 0px;
          margin-left: 8px;
        }

        .item-total {
          position: absolute;
          right: 0px;
          display: flex;
          height: 22px;
          color: rgb(255, 149, 0);
          font-size: 16px;
          font-weight: normal;
          letter-spacing: 0px;
        }
      }
    }

    .btn-cancel {
      width: 140px;
      height: 40px;
      position: absolute;
      left: 16%;
      bottom: 4%;
      font-size: 20px;
    }

    .btn-clear {
      width: 140px;
      height: 40px;
      background: linear-gradient(-74.89deg, rgb(228, 0, 255) -5.38%, rgb(0, 128, 255) 100%);
      border-radius: 4px;
      position: absolute;
      right: 42%;
      bottom: 4%;
      font-size: 20px;
      color: rgb(255, 255, 255);
      line-height: 20px;
      font-weight: normal;
      letter-spacing: 0px;
    }

    .detail-dialog-container {
      display: flex;
      flex-direction: column;
      margin: 0 24px;

      .detail-title-content {
        display: flex;
        line-height: 22px;
        color: rgb(51, 51, 51);
        font-size: 16px;
        font-weight: 600;
        letter-spacing: 0px;
        // margin-left: 24px;
      }

      .subtitle-content {
        display: flex;
        margin: 16px 0 8px 0;
        position: relative;

        .subtitle-text {
          width: 380px;
          line-height: 22px;
          color: rgb(51, 51, 51);
          font-size: 16px;
          font-weight: normal;
          letter-spacing: 0px;
        }

        .size-text {
          line-height: 22px;
          color: rgb(255, 149, 0);
          font-size: 16px;
          font-weight: normal;
          letter-spacing: 0px;
          position: absolute;
          right: 0;
        }
      }

      .table-content {
        height: 240px;
        overflow-y: auto;
      }

      .detail-dialog-bottom {
        height: 40px;
        margin-top: 8px;
      }
    }
  }

  .finish-content {
    width: 98%;
    height: 86%;
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;

    .finish-title {
      // position: absolute;
      margin-top: 11%;
      // left: 46%;
      display: flex;
      line-height: 56px;
      color: rgb(20, 102, 222);
      font-size: 40px;
      font-weight: normal;
      letter-spacing: 0px;
    }

    .finish-subtitle {
      // position: absolute;
      // top: 36%;
      // left: 42%;
      margin-top: 2.4%;
      display: flex;

      .subtitle-text {
        color: rgb(51, 51, 51);
        font-size: 26px;
        font-weight: normal;
        letter-spacing: 0px;
      }

      .value-text {
        color: rgb(255, 149, 0);
        font-size: 26px;
        font-weight: 600;
        letter-spacing: 0px;
      }
    }

    .time-cost-text {
      // position: absolute;
      // top: 48%;
      // left: 50%;
      margin-top: 2.4%;
      color: rgb(102, 102, 102);
      font-size: 16px;
      font-weight: 300;
      letter-spacing: 0px;
    }

    .btn-good {
      background: linear-gradient(-74.89deg, rgb(228, 0, 255) -5.38%, rgb(0, 128, 255) 100%);
      border-radius: 4px;
      // position: absolute;
      // right: 42%;
      // bottom: 24px;
      margin-top: 16%;
      font-size: 20px;
      color: rgb(255, 255, 255);
      line-height: 20px;
      font-weight: normal;
      letter-spacing: 0px;
    }
  }

  .icon-pic {
    position: absolute;
    bottom: 8px;
  }
}
</style>
